module.exports = __webpack_public_path__ + "static/media/record-audio-icon.19b1ac61.svg";